import { byPrefixAndName } from '@awesome.me/kit-4d9140695b/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Paragraph } from '../../typography';
import { FontAwesomeIcon as FontAwesomeIconEnum } from '../../types/fontAwesomeIcons';

export type ProductCardSpecItemProps =
  | { icon: typeof FontAwesomeIconEnum.RocketLaunch; text: string }
  | { icon: typeof FontAwesomeIconEnum.Users; text: string }
  | { icon: typeof FontAwesomeIconEnum.Clock; text: string }
  | { icon: typeof FontAwesomeIconEnum.Calendar; text: string }
  | { icon: typeof FontAwesomeIconEnum.Check; text: string }
  | { icon: typeof FontAwesomeIconEnum.CircleExclamation; text: string }
  | { icon: typeof FontAwesomeIconEnum.FaceFrown; text: string }
  | { icon: typeof FontAwesomeIconEnum.Ticket; text: string };

export const ProductCardSpecItem: React.FC<ProductCardSpecItemProps> = ({ icon, text }: ProductCardSpecItemProps) => {
  const getIconColor = () => {
    if (icon === FontAwesomeIconEnum.Check) return 'text-green-500';
    if (icon === FontAwesomeIconEnum.CircleExclamation) return 'text-red-600';
    return 'text-primary-black';
  };

  return (
    <div className="flex min-w-0 items-center gap-1.5">
      <FontAwesomeIcon icon={byPrefixAndName.fausb[icon]} className={`${getIconColor()} shrink-0`} />
      <Paragraph
        size="small"
        color={icon === FontAwesomeIconEnum.CircleExclamation ? 'red-600' : 'neutral-500'}
        className="text-wrap"
      >
        {text}
      </Paragraph>
    </div>
  );
};
